export type ConnectCastillaArgs = {
  body: { baseURL: string; appName: string; appToken: string };
  noAutoLogout: boolean;
  subsidiary?: string;
};

export type CastillaCredentialsResponse = {
  message: string;
};

export type CastillaConfig = {
  subsidiary: string;
  idEmpresa?: string;
  idConcepto?: string;
  recordTransactions: boolean;
  customFields?: Record<string, unknown> | null;
};

export type CastillaValues = CastillaConfig & {
  withCustomFields: boolean;
};

type CastillaCredentialKey = 'baseURL' | 'appName' | 'appToken';

export const step2InputList: Array<{ label: string; name: CastillaCredentialKey }> = [
  {
    label: 'integrations.castilla.base url',
    name: 'baseURL'
  },
  {
    label: 'integrations.castilla.app name',
    name: 'appName'
  },
  {
    label: 'integrations.castilla.app token',
    name: 'appToken'
  }
];

export const castillaInitialValues: CastillaValues = {
  subsidiary: '',
  recordTransactions: false,
  customFields: null,
  withCustomFields: false
};

export const mapFormDataToCastillaConfig = (formData: CastillaValues): CastillaConfig => {
  const baseConfig = {
    ...formData,
    customFields: formData.withCustomFields && formData.customFields ? formData.customFields : undefined
  };

  if (!formData.recordTransactions) {
    return {
      ...baseConfig,
      idEmpresa: undefined,
      idConcepto: undefined
    };
  }

  return baseConfig;
};
